import { render, staticRenderFns } from "./ModifySalePriceAndImmediateDiscount.vue?vue&type=template&id=072a4e8e&scoped=true&"
import script from "./ModifySalePriceAndImmediateDiscount.vue?vue&type=script&lang=ts&"
export * from "./ModifySalePriceAndImmediateDiscount.vue?vue&type=script&lang=ts&"
import style0 from "./ModifySalePriceAndImmediateDiscount.vue?vue&type=style&index=0&id=072a4e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a4e8e",
  null
  
)

export default component.exports